import React, {useState} from 'react'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import MomentLocaleUtils from 'react-day-picker/moment'
import {isMobile} from 'react-device-detect'
import styled from 'styled-components'
import prevIcon from 'img/circle-arrow-left-solid'
import nextIcon from 'img/circle-arrow-right-solid'
import time from 'i18n/time'

const StyledDayPicker = styled(DayPicker)`
  .DayPicker-wrapper {
    background-color: white;
    border: 1px solid var(--bs-primary);
    border-radius: 15px;
    padding: 0;
  }

  .DayPicker-Caption {
    font-size: 1em;
    /* background: var(--bs-primary); */
    color: var(--bs-white);
    padding: 0.35em 0.35em;


    > div {
      padding: 0.3em;
      background: var(--bs-primary);
      border-radius: var(--bs-border-radius-2xl);
    }
  }

  .DayPicker-NavButton {
      top: 0.65em;
      right: 0.75em;
      width: 2em;
  }

  .DayPicker-NavBar {
    color: var(--bs-primary);
  }

  .DayPicker-NavButton--prev {
    width: 1.5em;
    height: 1.5em;
    left: 0.75em;

    background-color: var(--bs-white);
    background-image: none;

    -webkit-mask: url(${prevIcon}) no-repeat center;
    -webkit-mask-size: contain;
    mask: url(${prevIcon}) no-repeat center;
    mask-size: contain;
  }

  .DayPicker-NavButton--next {
    width: 1.5em;
    height: 1.5em;
    right: 0.75em;

    background-color: var(--bs-white);
    background-image: none;

    -webkit-mask: url(${nextIcon}) no-repeat center;
    -webkit-mask-size: contain;
    mask: url(${nextIcon}) no-repeat center;
    mask-size: contain;
  }

  .DayPicker-Month {
    margin: 0em;
  }

  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
      background-color: red;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
      background-color: var(--bs-primary);
  }

  .DayPicker-Weekday {
    color: var(--bs-primary);
  }

  .DayPicker-Day {
    ${props => props.isMobile && `padding: 0.35em 0.5em;`}
    ${props => !props.isMobile && `padding: 0.6em 0.7em;`}
    font-size: 1.15em;
    font-weight: 700;
    border-radius: 0%;
    border: 1px solid #e9ecef
  }

  .DayPicker-Caption > div {
    text-align: center;
  }

  .DayPicker-Day--past {
    background: #f1f1f1;
    color: #cfcfcf;
  }

  .DayPicker-Day--today:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside) {
    color: var(--bs-dark);
  }
`;

const CalendarPicker = ({initialDay, daysAvailable, onDaySelected, onMonthChange, locale}) => {
  const firsSelectedDay = new Date(initialDay) || new Date()
  const [selectedDay, setSelectedDay] = useState(firsSelectedDay)

  const isDayDisabled = (day) => {
    const localTime = time.tz(day, "Europe/Madrid").format('YYYY-MM-DD')

    if (!daysAvailable) {
      return false
    }

    const isDayMatch = daysAvailable.some(enabledDay => {
      return localTime == enabledDay
    })

    return !isDayMatch
  }

  const handleDayClick = (day, {disabled}) => {
    if (disabled) {
      return
    }

    setSelectedDay(day)
    onDaySelected(day)
  }

  const handleMonthChange = (day) => {
    onMonthChange(day)
  }

  const modifiers = {
    today: new Date(),
    past: { from: new Date(1900, 0, 1), to: time().add(-1, 'days').toDate() }
  };

  return (
    <StyledDayPicker
      selectedDays={selectedDay}
      onDayClick={handleDayClick}
      onMonthChange={handleMonthChange}
      disabledDays={[
        isDayDisabled,
        {before: firsSelectedDay}
      ]}
      fromMonth={firsSelectedDay}
      initialMonth={firsSelectedDay}
      showOutsideDays
      localeUtils={MomentLocaleUtils}
      locale={locale}
      firstDayOfWeek={1}
      isMobile={isMobile}
      modifiers={modifiers}
    />
  )
}

export default CalendarPicker
